// Exports
export default {
	"nativeAppBanner": "nativeAppBanner_AwtYA",
	"title": "title_b1xG9"
};
